import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import BeatAddAndEditModal from "./components/BeatAddEditModal";
import { useBeatData, useGetOrgUnitsData } from "./hooks/useBeat";
import { FaEdit, FaEye } from "react-icons/fa";
import CustomDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { getAllTerritory, getTownFilter } from "./hooks/BeatRepository";
import { useExcelPolling } from "../../../hooks/useExcelPolling";
import { COLORS } from "../../../constants/colors";
import { showToast } from "../../../utils/toastUtils";
import axiosInstance from "../../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../../Api/apiEndPoints";

const BeatsColumns = (
  handleEditBeat: (row: any) => void,
  handleView: (row: any) => void
) => [
  {
    name: "Beat Name",
    selector: (row: { BeatName: string }) => row.BeatName || "-",
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Beat Code",
    selector: (row: { BeatCode: string }) => row.BeatCode || "-",
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Territory",
    selector: (row: { TerritoryName: any }) => row?.TerritoryName || "-",
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Territory Code",
    selector: (row: { Territories: any }) =>
      row?.Territories?.TerritoryCode || "-",
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Town",
    selector: (row: { TownName: any }) => row?.TownName || "-",
    sortable: true,
    wrap: true,
    width: "180px",
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center" style={{}}>
        <div className="d-flex align-items-center">
          <button
            onClick={() => handleEditBeat(row)}
            className="btn btn-primary"
            style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
          </button>
        </div>
        <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
          <button
            onClick={() => handleView(row)}
            className="btn btn-primary"
            style={{
              borderRadius: "20px",
              padding: "2px",
              width: "70px",
              backgroundColor: "#2e8dd3",
            }}
          >
            <FaEye style={{ fill: "#fff" }} />
            View
          </button>
        </div>
      </div>
    ),
    width: "200px",
  },
];

const Beats = () => {
  const navigate = useNavigate();
  const {stopPolling,startPolling} = useExcelPolling();
  const [paginationStates, setPaginationStates] = useState<any>({
    TerritoryId: null,
    TownId: null,
    limit: 10,
    page: 1,
    search: null,
  });
  const [selectedTerritoryId, setSelectedTerritoryId] = useState<
    string | number | null
  >(null);
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });

  const [rowData, setRowData] = useState<any>({});
  const { data: beatsData, isLoading: isLoading } = useBeatData({
    enable: true,
    params: {
      TerritoryId: paginationStates.TerritoryId,
      limit: paginationStates.limit,
      page: paginationStates.page,
      search: paginationStates.search,
      TownId: paginationStates.TownId,
    },
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
   const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
   const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
   
  const handleEditBeat = (row: any) => {
    setRowData(row);
    setCheckAddEditStatus("Edit");
    setIsModalOpen(true);
  };
  const handleView = (row: any) => {
    navigate("/beatOutletMapping", { state: { beatRowData: row } });
  };
  const toggleModal = () => {
    setCheckAddEditStatus("Add");
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


   const downloadExcelGet = async () => {
    const param: Record<string, any> = {
     ...(paginationStates.TerritoryId === null? {}:{TerritoryId:paginationStates.TerritoryId}),
    ...(paginationStates.TownId=== null? {}:{TownId:paginationStates.TownId})
    };

    const queryString = new URLSearchParams(param).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.Beat.GET_EXCET_BEAT}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus('Loading..');
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) =>{ 
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "")
            stopPolling();
            setLoadingExcel(false);
          }
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };
  return (
    <div className="p-4">
      <PageHeader
        title="Beats/Patches"
        buttons={[
          {
            label: "+ Add Beat",
            onClick: toggleModal,
            color: COLORS.primary,
          },
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        paginationTotalRows={beatsData?.data?.recordsTotal || 0}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Beats"
        columns={BeatsColumns(handleEditBeat, handleView)}
        data={beatsData?.data?.data || []}
        showSpinner={isLoading}
        headerContent={
          <>
            <CustomDropdown
              placeholder="All Territories"
              DropdownLabel="Territory"
              value={selectedTerritoryId}
              onChange={(id) => {
                setSelectedTerritoryId(id);
                setPaginationStates((prev: any) => ({
                  ...prev,
                  TerritoryId: id,
                  TownId: null,
                  page: 1,
                }));
              }}
              fetchData={({ page, limit, search }) =>
                getAllTerritory({ page, limit, search }).then((res) => {
                  const data = res?.data?.data?.data || [];
                  let formatted = data.map((item: any) => ({
                    id: item.TerritoryId,
                    label: item.TerritoryName,
                  }));
                  formatted = [{ id: "", label: "All" }, ...formatted];
                  return {
                    data: formatted,
                    hasMore: data.length === limit,
                  };
                })
              }
              includeAllOption
            />

            {selectedTerritoryId !== null && selectedTerritoryId !== "" && (
              <CustomDropdown
                key={selectedTerritoryId}
                placeholder="All Towns"
                DropdownLabel="Town"
                value={paginationStates?.TownId}
                onChange={(id) =>
                  setPaginationStates((prev: any) => ({
                    ...prev,
                    TownId: id,
                    page: 1,
                  }))
                }
                fetchData={({ page, limit, search }) =>
                  getTownFilter({
                    page,
                    limit,
                    search,
                    territoryId: selectedTerritoryId,
                  }).then((res) => {
                    const rawData = res?.rowData?.data?.TownsData || {};
                    let formatted = Object.entries(rawData).map(
                      ([id, label]: any) => ({
                        id,
                        label: label.trim(),
                      })
                    );
                    formatted = [{ id: "", label: "All" }, ...formatted];
                    return {
                      data: formatted,
                      hasMore: Object.keys(rawData).length === limit,
                    };
                  })
                }
                includeAllOption
              />
            )}
          </>
        }
      />
      <BeatAddAndEditModal
        rowData={rowData}
        OrgUnitData={orgUnitsList?.data}
        setCheckAddEditStatus={setCheckAddEditStatus}
        checkAddEditStatus={checkAddEditStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        title={checkAddEditStatus == "Add" ? "Add Beat" : "Edit Beat"}
      />
    </div>
  );
};

export default Beats;
